<template>
  <div>
    <report-title
      title='Balance Sheet'
      :subtitle='subtitle'
    ></report-title>
    <v-simple-table dense>
      <tbody>
        <tr>
          <td style='border-bottom: solid 1px;' class='pl-0' colspan='3'>
            <report-header text='Assets'></report-header>
          </td>
        </tr>
        <bs-line v-for='l in assets' :key='l.id' :line='l' @lineClick='lineClick'></bs-line>

        <tr>
          <td style='border-bottom: solid 2px;' class='pl-0'>
            <total-header text='Total Assets'></total-header>
          </td>
          <td style='border-bottom: solid 2px;' class='pl-0'></td>
          <td style='border-bottom: solid 2px;' class='pl-0 text-right'>
            <total-header :text='total_assets | decAccounting'></total-header>
          </td>
        </tr>
        <tr>
          <td style='border-bottom: solid 1px;' class='pl-0' colspan='3'>
            <report-header text='Liabilities'></report-header>
          </td>
        </tr>
        <bs-line v-for='l in liabilities' :key='l.id' :line='l' @lineClick='lineClick'></bs-line>
        <tr>
          <td style='border-bottom: solid 1px;' class='pl-0' colspan='3'>
            <report-header text='Equity'></report-header>
          </td>
        </tr>
        <bs-line :line='closing_re'></bs-line>
        <tr>
          <td style='border-bottom: solid 2px;' class='pl-0'>
            <total-header text='Total Liabilities and Equity'></total-header>
          </td>
          <td style='border-bottom: solid 2px;' class='pl-0'></td>
          <td style='border-bottom: solid 2px;' class='pl-0 text-right'>
            <total-header :text='liabilities_and_re | decAccounting'></total-header>
          </td>
        </tr>
      </tbody>
    </v-simple-table>

    <account-transaction-dialog
      :showDialog='showDialog'
      :transactions='transactions'
      :title='title'
      :loading='loadingTransactions'
      @close='showDialog = false'
    ></account-transaction-dialog>

  </div>
</template>

<script>
import BSLine from './BSLine';
import ReportHeader from './ReportHeader';
import ReportTotalHeader from './ReportTotalHeader';
import ReportTitle from './ReportTitle';
import AccountTransactionDialog from './AccountTransactionDialog';
import bookkeepingAPI from '@/api/accounting';
import _ from 'lodash';

export default {
  name: 'balance-sheet-report',
  props: {
    net_income: {
      required: true
    },
    accounts: {
      required: true
    },
    as_at: {
      required: true
    }
  },
  data: () => ({
    showDialog: false,
    loadingTransactions: true,
    title: '',
    transactions: []
  }),
  computed: {
    subtitle () {
      return 'As at ' + this.$options.filters.longDate(this.as_at)
    },
    assets () {
      return this.accounts.filter(a => a.account_type == 'A')
    },
    liabilities () {
      return this.accounts.filter(a => a.account_type == 'L')
    },
    equity () {
      return this.accounts.filter(a => a.account_type == 'Q')
    },
    closing_re () {
      let opening_re = this.equity.find(a => a.number === 3100)
      let tmp = {}
      if (opening_re) {
        tmp = {
          number: '',
          name: 'Retained Earnings',
          balance: opening_re.balance + this.net_income.balance
        }
      } else {
        tmp = {
          number: '',
          name: 'Retained Earnings',
          balance: 0
        }
      }
      return tmp
    },
    liabilities_and_re () {
      let accts = _.filter(this.liabilities, l => !l.is_grouping && !l.group_total)
      let l_total = _.sumBy(accts, 'balance')
      return this.closing_re.balance + l_total
    },
    total_assets () {
      let accts = _.filter(this.assets, a => !a.is_grouping && !a.group_total)
      return _.sumBy(accts, 'balance')
    }
  },
  methods: {
    async lineClick (line) {
      if (!line.is_header && !line.group_total) {
        this.transactions = [];
        this.showDialog = true;
        this.loadingTransactions = true;
        this.title = line.name + ' Transactions';
        this.transactions = await bookkeepingAPI.getAccountTransactions(line.id, null, this.as_at);
        this.loadingTransactions = false;
      }
    }
  },
  components: {
    'bs-line': BSLine,
    'report-header': ReportHeader,
    'total-header': ReportTotalHeader,
    'report-title': ReportTitle,
    'account-transaction-dialog': AccountTransactionDialog
  }
}

</script>

